import '../App.css';
import { BarChartDifficulty, BarChartTime, PieChart } from '../components/Chart';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import env from "react-dotenv"
import { Header } from '../components/Header';

const Home = () => {
    let navigate = useNavigate();

    useEffect(() => {
        // Change background color
        document.body.style.backgroundColor = "#f8f9fe"

        const fetchUsers = async () => {
            const res = await fetch(env.BACKEND_URL + "/admin/users", {
                method: "GET",
                credentials: 'include'  
            });

            const data = await res.json();

            var ageData = [0, 0, 0, 0];
            var genderData = [0, 0];
            var cerebralTimeMale = [0.0, 0.0, 0.0, 0.0];
            var cerebralTimeFemale = [0.0, 0.0, 0.0, 0.0];
            var spatialTimeMale = [0.0, 0.0, 0.0, 0.0];
            var spatialTimeFemale = [0.0, 0.0, 0.0, 0.0];
            var numUsersMale = [0, 0, 0, 0];
            var numUsersFemale = [0, 0, 0, 0];
            var difficultiesMale = [0, 0, 0, 0];
            var difficultiesFemale = [0, 0, 0, 0];
            var difficulties3DMale = [0, 0, 0, 0];
            var difficulties3DFemale = [0, 0, 0, 0];

            data.forEach(user => {
                console.log(user);
                // Age chart
                if (user.age >= 0 && user.age <= ageData.length)
                    ageData[user.age]++;

                if (user.gender) // if is female
                    genderData[1]++;
                else
                    genderData[0]++;

                
                if (user.gender) {
                    // Cerebral chart (time)
                    cerebralTimeFemale[user.age] += user.time;
                    spatialTimeFemale[user.age] += user.time3d;

                    // Num users
                    numUsersFemale[user.age]++;

                    // Difficulty chart
                    difficultiesFemale[user.age] += user.difficulty;
                    difficulties3DFemale[user.age] += user.difficulty3d;
                } else {
                    // Cerebral chart (time)
                    cerebralTimeMale[user.age] += user.time;
                    spatialTimeMale[user.age] += user.time3d;

                    // Num users
                    numUsersMale[user.age]++;

                    // Difficulty chart
                    difficultiesMale[user.age] += user.difficulty;
                    difficulties3DMale[user.age] += user.difficulty3d;
                }

                
                
            });

            for (let i = 0; i < 4; i++) {
                if (numUsersMale[i] > 0) {
                    cerebralTimeMale[i] /= numUsersMale[i];
                    cerebralTimeMale[i] /= 60; // Minutes to hour
                    spatialTimeMale[i] /= numUsersMale[i];
                    spatialTimeMale[i] /= 60; // Minutes to hour
                    difficultiesMale[i] /= numUsersMale[i];
                    difficulties3DMale[i] /= numUsersMale[i];
                }

                if (numUsersFemale[i] > 0) {
                    cerebralTimeFemale[i] /= numUsersFemale[i];
                    cerebralTimeFemale[i] /= 60; // Minutes to hour
                    spatialTimeFemale[i] /= numUsersFemale[i];
                    spatialTimeFemale[i] /= 60; // Minutes to hour
                    difficultiesFemale[i] /= numUsersFemale[i];
                    difficulties3DFemale[i] /= numUsersFemale[i];
                }
            }
            
    
            setAgeChartData({
                labels: ["Moins de 20 ans", "Entre 20 et 40 ans", "Entre 41 et 60 ans", "Plus de 61 ans"],
                datasets: [
                    {
                        label: "Age",
                        data: ageData,
                        backgroundColor: [
                            '#0a417a',
                            '#81c3d7',
                            '#db5461',
                            '#af4d98'
                        ],
                    }
                ]
            })
    
            setGenderChartData({
                labels: ["Homme", "Femme"],
                datasets: [
                    {
                        label: "Sexe",
                        data: genderData,
                        backgroundColor: [
                            '#66c1f8',
                            '#f1689d'
                        ],
                    }
                ]
            })

            setCerebralTimeData({
                labels: ["Moins de 20 ans", "Entre 20 et 40 ans", "Entre 41 et 60 ans", "Plus de 61 ans"],
                datasets: [
                    {
                        label: "Homme",
                        data: cerebralTimeMale,
                        backgroundColor: [
                            '#66c1f8',
                            '#66c1f8',
                            '#66c1f8',
                            '#66c1f8'
                        ],
                        stack: "Stack 0",
                    },
                    {
                        label: "Femme",
                        data: cerebralTimeFemale,
                        backgroundColor: [
                            '#f1689d',
                            '#f1689d',
                            '#f1689d',
                            '#f1689d'
                        ],
                        stack: "Stack 1",
                    },
                ],
            })

            setSpatialTimeData({
                labels: ["Moins de 20 ans", "Entre 20 et 40 ans", "Entre 41 et 60 ans", "Plus de 61 ans"],
                datasets: [
                    {
                        label: "Homme",
                        data: spatialTimeMale,
                        backgroundColor: [
                            '#66c1f8',
                            '#66c1f8',
                            '#66c1f8',
                            '#66c1f8'
                        ],
                        stack: "Stack 0",
                    },
                    {
                        label: "Femme",
                        data: spatialTimeFemale,
                        backgroundColor: [
                            '#f1689d',
                            '#f1689d',
                            '#f1689d',
                            '#f1689d'
                        ],
                        stack: "Stack 1",
                    },
                ],
                
            })

            setCerebralDifficultyData({
                labels: ["Moins de 20 ans", "Entre 20 et 40 ans", "Entre 41 et 60 ans", "Plus de 61 ans"],
                datasets: [
                    {
                        label: "Homme",
                        data: difficultiesMale,
                        backgroundColor: [
                            '#66c1f8',
                            '#66c1f8',
                            '#66c1f8',
                            '#66c1f8'
                        ],
                        stack: "Stack 0",
                    },
                    {
                        label: "Femme",
                        data: difficultiesFemale,
                        backgroundColor: [
                            '#f1689d',
                            '#f1689d',
                            '#f1689d',
                            '#f1689d'
                        ],
                        stack: "Stack 1",
                    },
                ]
            })

            setSpatialDifficultyData({
                labels: ["Moins de 20 ans", "Entre 20 et 40 ans", "Entre 41 et 60 ans", "Plus de 61 ans"],
                datasets: [
                    {
                        label: "Homme",
                        data: difficulties3DMale,
                        backgroundColor: [
                            '#66c1f8',
                            '#66c1f8',
                            '#66c1f8',
                            '#66c1f8'
                        ],
                        stack: "Stack 0",
                    },
                    {
                        label: "Femme",
                        data: difficulties3DFemale,
                        backgroundColor: [
                            '#f1689d',
                            '#f1689d',
                            '#f1689d',
                            '#f1689d'
                        ],
                        stack: "Stack 1",
                    },
                ]
            })

        }
    
        fetchUsers();
    }, [])
    
    const [ageChartData, setAgeChartData] = useState({});
    const [genderChartData, setGenderChartData] = useState({});
    const [cerebralTimeData, setCerebralTimeData] = useState({});
    const [spatialTimeData, setSpatialTimeData] = useState({});
    const [cerebralDifficultyData, setCerebralDifficultyData] = useState({});
    const [spatialDifficultyData, setSpatialDifficultyData] = useState({});

    /*async function handleDisconnect() {
        const res = await fetch(env.BACKEND_URL + "/admin/logout", {
            method: "GET",
            credentials: "include"
        });

        if (res.ok)
            navigate("/");
    }*/
    
    return (
        <div>
            <Header navigate={navigate}></Header>
           
            <div className="charts-row">
                <div className="row-title">
                    Répartition des joueurs
                </div>
                <div className="chart-left">
                    { ageChartData.labels ? <PieChart chartData={ageChartData} title={"Par tranche d'âge"} /> : null }
                </div>
                <div className="chart-right">
                    { genderChartData.labels ? <PieChart chartData={genderChartData} title={"Par sexe"}/> : null }
                </div>
            </div>
            <div className="charts-row">
                <div className="row-title">
                    Temps de jeu moyen
                </div>
                <div className="chart-left">
                    { cerebralTimeData.labels ? <BarChartTime chartData={cerebralTimeData} title={"Entrainement cérébral"} /> : null }
                </div>
                <div className="chart-right">
                    { spatialTimeData.labels ? <BarChartTime chartData={spatialTimeData} title={"Repère spatial"} /> : null }
                </div>
            </div>
            <div className="charts-row">
                <div className="row-title">
                    Nombre de niveau réussi
                </div>
                <div className="chart-left">
                    { cerebralDifficultyData.labels ? <BarChartDifficulty chartData={cerebralDifficultyData} title={"Entrainement cérébral"} /> : null }
                </div>
                <div className="chart-right">
                    { spatialDifficultyData.labels ? <BarChartDifficulty chartData={spatialDifficultyData} title={"Repère spatial"} /> : null }
                </div>
            </div>
  
        </div>
    );
}


export default Home;


    